const common = {
  phone: "(702) 604-2093",
  phoneRaw: "+17026042093",
  callNow: "Llamar Ahora",
  getFreeQuote: "Cotización Gratis",
  getMyFreeEstimate: "Obtener Mi Estimado Gratis",
  freeEstimate: "Estimado Gratis",
  viewAllServices: "Ver Todos los Servicios",
  viewAllServiceAreas: "Ver Todas las Áreas",
  viewFullGallery: "Ver Galería Completa",
  learnMore: "Saber Más",
  sendingLabel: "Enviando...",
  requestReceived: "¡Solicitud Recibida!",
  requestReceivedDesc: "Nos comunicaremos con usted en 24 horas con su estimado gratuito.",
  fullName: "Nombre Completo",
  phone_field: "Teléfono",
  email: "Correo Electrónico",
  serviceNeeded: "Servicio Necesario",
  message: "Mensaje",
  selectService: "Seleccione un servicio...",
  describeProject: "Describa su proyecto...",
  tellUsProject: "Cuéntenos sobre su proyecto...",
  submitConsent: "Al enviar, acepta ser contactado sobre su proyecto.",
  noObligation: "Sin compromiso. Respondemos en 24 horas.",
  nav_home: "Inicio",
  nav_services: "Servicios",
  nav_areas: "Áreas de Servicio",
  nav_blog: "Blog",
  lang_en: "EN",
  lang_es: "ES",
  switchLang: "English",
  footerTagline: "Soluciones Premium de Vidrio y Espejos",
  footerDesc: "Instalaciones de vidrio de precisión para hogares y negocios en todo el Valle de Las Vegas. Moderno, sin marco y duradero.",
  footerServices: "Servicios",
  footerAreas: "Áreas de Servicio",
  footerCompany: "Empresa",
  footerRights: "Todos los derechos reservados. Las Vegas, NV.",
  privacy: "Política de Privacidad",
  terms: "Términos de Servicio",
  stayUpdated: "Manténgase Informado",
  subscribe: "Suscribirse",
};

export default common;
